'use strict';
module.exports = {
	stdout: false,
	stderr: false
};



//////////////////
// WEBPACK FOOTER
// ./~/pino-pretty/~/supports-color/browser.js
// module id = 3329
// module chunks = 16